var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('country-flag',{staticClass:"flag-icon",attrs:{"rounded":_vm.rounded,"size":_vm.size,"country":_vm.isoName.toLowerCase()}})}
var staticRenderFns = []

export { render, staticRenderFns }